import React from 'react';
import { connect } from 'react-redux';
import FilterIndex from './filterIndex/filterIndex';
import './filterDisplay.scss';

class FilterDisplay extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { resultsConfig, assessment } = this.props;

        const heading = resultsConfig?.filterHeading || 'Your selections';
        if (resultsConfig?.hideFilters) {
            return null;
        }
        return (
            <div className='content-container border'>
                <div className='preferences'>
                    <h2 className={`heading-mt ${assessment.site}`}>{heading}</h2>
                    
                    <FilterIndex />
                </div>
            </div>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        resultsConfig: state.app.assessment.resultsConfig,
        assessment: state.app.assessment,
    };
};

export default connect(mapStateToProps, null)(FilterDisplay);